import { useContext } from 'react';
import { CollapseSettingDrawerContext } from 'src/contexts/CollapseSettingDrawerContext';

// ----------------------------------------------------------------------

const useCollapseSettingDrawer = () => useContext(CollapseSettingDrawerContext);

export default useCollapseSettingDrawer;
